import React, { useState } from "react";
import { Button } from "@mui/material";
import Navbar from "../sections/Navbar";
import HeroSection from "../sections/HeroSection";
import HighlightSection from "../sections/HighlightSection";
import ServicesSection from "../sections/ServicesSection";
import PortfolioSection from "../sections/PortfolioSection";
import MessageSection from "../sections/MessageSection";
import ContactSection from "../sections/ContactSection";
import HeadTitle from "../sections/HeadTitle";
import styles from "./HomePage.module.css";

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={styles.mainDesign}>
      <Navbar />
      <HeroSection
        onModalOpen={() => setIsModalOpen(true)}
        onModalClose={() => setIsModalOpen(false)}
      />
      <HighlightSection />
      <ServicesSection />
      <section className={styles.banner}>
        <video
          className={styles.bgVideo}
          src="/create_a_banner_vedio.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <h1 className={styles.craftedBeauty}>Crafted Beauty</h1>
      </section>
      <PortfolioSection />
      <MessageSection formSource="Home Page Contact Section" />
      <ContactSection />
      <div className={styles.footerContainer}>
        <div className={styles.footer}>
          <div className={styles.shakaDesignsLlp}>
            ©2024 | ShaKa Design Lab LLP. All rights reserved.<br />
            <span style={{ fontSize: "0.85em", opacity: 0.8, marginTop: "4px", display: "inline-block" }}>
              Managed by <a href="https://theelevatedigi.com" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "underline" }}>Elevatedigi</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
